import { render, staticRenderFns } from "./HsabInvestmentAccountRedirectLink.vue?vue&type=template&id=23fa975b&scoped=true"
import script from "./HsabInvestmentAccountRedirectLink.vue?vue&type=script&lang=ts"
export * from "./HsabInvestmentAccountRedirectLink.vue?vue&type=script&lang=ts"
import style0 from "./HsabInvestmentAccountRedirectLink.vue?vue&type=style&index=0&id=23fa975b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa975b",
  null
  
)

export default component.exports